import { render, staticRenderFns } from "./dangan-detail.vue?vue&type=template&id=5c7fd924"
import script from "./dangan-detail.vue?vue&type=script&lang=ts"
export * from "./dangan-detail.vue?vue&type=script&lang=ts"
import style0 from "./dangan-detail.vue?vue&type=style&index=0&id=5c7fd924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports